import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to CDN
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
preconnectCDN.crossOrigin = 'anonymous';
document.head.appendChild(preconnectCDN);
// Preload critical LCP image
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = 'https://cdn.magicpatterns.com/uploads/db55hm39pPvsCQxNyf8uNx/zumba_mockup_webp_sin_fondo.webp';
preloadHero.type = 'image/webp';
document.head.appendChild(preloadHero);
render(<App data-id="element-372" />, document.getElementById('root'));